module.exports = __webpack_public_path__ + "img/rocket-blue.c44bdac0.svg";